<template>
    <!-- 公司资质 1  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :right-bg="rightBg" :right-bg2="rightBg2" :partition="[7, 5]" />
</template>

<script>
import SubPage from "./components/SubPage.vue";
export default {
    name: 'licenseOne',
    components: {
        SubPage
    },
    data() {
        return {
            rightBg: "/img/pay/0--63.png",
            rightBg2: "/img/pay/0--64.png",
            bg: "/img/pay/0--36.png",
        }
    },
    computed: {
        title() {
            return this.$t('licenseOne.title');
        },
        subtitle() {
            return this.$t('licenseOne.subtitle');
        },
        description() {
            const desc = this.$t('licenseOne.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
}
</script>
